import { render } from "./DocumentExpiration.vue?vue&type=template&id=e99c58ca"
import script from "./DocumentExpiration.vue?vue&type=script&lang=js"
export * from "./DocumentExpiration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__